import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const EventWorldMapIcon: FC<IconSvgProps> = ({ color }) => {
    return (
        <svg width="138" height="100" viewBox="0 0 138 100" version="1.1">
            <defs>
                <filter x="-58.1%" y="-119.4%" width="216.2%" height="338.9%" filterUnits="objectBoundingBox" id="filter-1">
                    <feOffset dx="5" dy="6" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="8" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix
                        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.231377021 0"
                        type="matrix"
                        in="shadowBlurOuter1"
                        result="shadowMatrixOuter1"
                    ></feColorMatrix>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
                <path
                    d="M74,0 L60.2323849,31.2813682 L47.361,31.281 L42.6852764,36 L38.009,31.281 L0,31.2813682 L13.764605,0 L74,0 Z"
                    id="path-2"
                ></path>
            </defs>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="D_UI_LIST_OF_EVENTS_ZOOM_HOVER" transform="translate(-490.000000, -617.000000)">
                    <g id="Group-6-Copy-3" filter="url(#filter-1)" transform="translate(522.000000, 649.000000)">
                        <mask id="mask-3" fill="white">
                            <use xlinkHref="#path-2"></use>
                        </mask>
                        <use id="Combined-Shape" fill={color} xlinkHref="#path-2"></use>
                        <polygon
                            id="Fill-652"
                            fill="#000D44"
                            mask="url(#mask-3)"
                            points="7.74874126 0 -7.52137323 31.2814605 7.86642262 31.2814605 20.0218238 4.87091688 20.3837872 5.16375517 22.7585297 0"
                        ></polygon>
                        <polygon
                            id="Fill-642"
                            fill="#0F1428"
                            opacity="0.699999988"
                            mask="url(#mask-3)"
                            points="22.5449193 6.97948178 47.3715901 -46.9693974 44.9097471 -48.1342902 20.3837872 5.16117103 20.0218238 4.86833274 -1.58285339 51.8156727 0.878989635 52.9805655 22.1829559 6.6865512"
                        ></polygon>
                        <polygon
                            id="Fill-645"
                            fill="#0F1428"
                            opacity="0.5"
                            mask="url(#mask-3)"
                            points="26.8583552 10.6128731 51.2541648 -42.3998096 48.7923217 -43.5647024 24.6972231 8.79456235 24.3351686 8.50172406 2.29972126 56.3852606 4.76156429 57.5501534 26.4963917 10.3199425"
                        ></polygon>
                        <polygon
                            id="Fill-648"
                            fill="#0F1428"
                            opacity="0.200000003"
                            mask="url(#mask-3)"
                            points="31.1806194 14.2569701 55.1796071 -37.8932563 52.7177641 -39.0582414 29.0194873 12.4386594 28.6574329 12.1458211 6.22507258 60.8917216 8.68691561 62.0566144 30.818656 13.9640395"
                        ></polygon>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default EventWorldMapIcon;
